import leaveStore from "./leave/store";
import exemptionStore from "./exemption/store";
import reportsStore from "./reports/store";

export default {
  namespaced: true,
  modules: {
    leave: leaveStore,
    exemption: exemptionStore,
    reports: reportsStore,
  },
};
